import classes from "./Title.module.css";

export const Title = () => {
  return <h1 className={classes.title}>Список пользователей</h1>;
};
